// تأكيد قبل البصمة — «هل أنت متأكّد أنك تسجّل الآن؟».
//
// لماذا وُجد: الحضور والانصراف **حدثان لا يُحذفان** (`attendance_events` بلا حذف ولا تعديل،
// وتصحيح المكرر يمرّ بقسم خاص). فالنقرة غير المقصودة — أو المكرَّرة لأن الموظف لم يتبيّن أنه
// سجّل — تترك في سجلّه أثرًا يُشرح ولا يُمحى. ثانيةٌ واحدة من التأكيد أرخص من ذلك بكثير.
//
// والنصّ يقول ثلاثة أشياء لا يعرفها الموظف من الزرّ وحده: أن البصمة **الآن**، وأن الوقت
// **من الخادم** لا من ساعة جهازه، وأن التسجيل **لا يُحذف**. وما يخصّ الموقع يُقال كما هو:
// يُقرأ لحظة الضغط، ورفضه لا يمنع التسجيل.
//
// ومصدر واحد للنصّ: تستعمله شاشة «حضوري» وزرّ الترويسة السريع معًا، فلا يختلف التحذير
// باختلاف المكان الذي ضُغط منه الزرّ. ولا يغيّر هذا المكوّن قاعدة واحدة: لا يشترط ترتيبًا
// بين الحضور والانصراف، ولا يمنع نقرة، ولا يقرأ حالة الزرّ الآخر — يسأل ثم ينقل الإجابة.
import type { AttendanceKind } from '../lib/api.ts';
import { Modal } from '../components/ui.tsx';

const TITLE: Record<AttendanceKind, string> = {
  CHECK_IN: 'تأكيد تسجيل الحضور',
  CHECK_OUT: 'تأكيد تسجيل الانصراف',
};
const CONFIRM: Record<AttendanceKind, string> = {
  CHECK_IN: 'نعم، سجّل حضوري الآن',
  CHECK_OUT: 'نعم، سجّل انصرافي الآن',
};
const NOUN: Record<AttendanceKind, string> = { CHECK_IN: 'حضورك', CHECK_OUT: 'انصرافك' };

export function TapConfirm(
  { kind, busy, onCancel, onConfirm }:
  { kind: AttendanceKind; busy: boolean; onCancel: () => void; onConfirm: () => void },
) {
  return (
    // نافذة صغيرة في وسط الشاشة: سؤالٌ واحد وجوابه، وتُغلق فور انتهاء التسجيل
    <Modal title={TITLE[kind]} size="sm" onClose={() => { if (!busy) onCancel(); }}>
      <div className="space-y-3">
        <p className="text-base text-ink-900">
          سيُسجَّل {NOUN[kind]} <strong>الآن</strong> — هل تريد المتابعة؟
        </p>
        {/*
          سطران لا أكثر (قرار المالك): ما يخصّ **صحّة التسجيل** وحده — الوقت من الخادم،
          والتسجيل لا يُمحى. وما كان يُقال عن الموقع حُذف من هنا بقراره؛ ولم يتغيّر شيء في
          السلوك: المتصفّح نفسه يستأذن الموظف قبل قراءة الموقع، وسجلّ بصماته يقول عن كل
          بصمة «الموقع مُسجَّل» أو «الموقع غير متاح» — فلا شيء يُقرأ خلسةً.
        */}
        <ul className="list-inside list-disc space-y-1 text-xs text-ink-600">
          <li>الوقت من <strong>الخادم</strong> بتوقيت القاهرة، لا من ساعة جهازك.</li>
          <li>التسجيل <strong>لا يُحذف</strong> بعده — والتصحيح بسجلّ لا بمحو.</li>
        </ul>
        <div className="flex flex-wrap gap-2">
          <button type="button" className="btn-primary px-4 py-2" disabled={busy} onClick={onConfirm}>
            {busy ? 'جارٍ التسجيل…' : CONFIRM[kind]}
          </button>
          <button type="button" className="btn-ghost px-4 py-2" disabled={busy} onClick={onCancel}>تراجع</button>
        </div>
      </div>
    </Modal>
  );
}
